import { Box, Flex } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GamePanelPages } from '../gamePanel';

interface IPanelNavigation {
	selectPage: (pages: GamePanelPages) => void;
	selectedPage: GamePanelPages;
	platforms: string[];
}

export const PanelNavigation: FC<IPanelNavigation> = ({ selectPage, selectedPage, platforms }) => {
	const { t } = useTranslation();

	const menuItems: any[] = useMemo(() => {
		return [
			{
				value: GamePanelPages.CHART,
				name: t('yourGames.tabs.chart'),
			},
			{
				value: GamePanelPages.PRICING,
				name: t('yourGames.tabs.manage'),
			},
			{
				value: GamePanelPages.UPLOAD,
				name: t('yourGames.tabs.upload'),
			},
			{
				value: GamePanelPages.METADATA,
				name: t('yourGames.tabs.metadata'),
			},
			{
				value: GamePanelPages.MIGRATION,
				name: t('yourGames.tabs.migration'),
			},
			{
				value: GamePanelPages.CODE,
				name: 'Code Editor',
			},
		];
	}, [t]);

	return (
		<Flex
			gridGap="18px"
			m="40px 0px"
		>
			{menuItems.map(menuItem => {
				const isSelected = selectedPage === menuItem.value;
				if (menuItem.value == GamePanelPages.CODE && !platforms.includes('web3')) return;
				if (menuItem.value == GamePanelPages.UPLOAD && !platforms.includes('pc') && !platforms.includes('html'))
					return;

				return (
					<Box
						cursor="pointer"
						position="relative"
						opacity={isSelected ? '1' : '0.6'}
						onClick={() => selectPage(menuItem.value)}
						fontWeight={isSelected ? 'bold' : 'normal'}
						fontSize="14px"
						key={menuItem.name}
					>
						{isSelected && (
							<Box
								position="absolute"
								w="10px"
								h="2px"
								bottom="-6px"
								left="0px"
								bg="cartridge.red"
							/>
						)}
						{menuItem.name}
					</Box>
				);
			})}
		</Flex>
	);
};
